document.addEventListener("DOMContentLoaded", function(){
  var bold_save_product_scripts = Array.from(document.getElementsByClassName("bold_save_product"));
  var productPlaceHolders = Array.from(document.querySelectorAll("div[id^='product-grid-item-'][data-handle].bold_product_placeholder"));
  var remained = productPlaceHolders.length;
  productPlaceHolders.forEach(function(productPlaceHolder){
    var handle = productPlaceHolder.dataset.handle;
    var url = 'https://' + location.host + "/products/" + handle + "?view=mini"; 
    var request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        --remained;
 
        var htmlString = request.responseText;
 
        if(window.section_settings && Object.keys(section_settings) && Object.keys(section_settings).length > 0){
          Object.keys(section_settings).forEach(function(key){
            var regExp = new RegExp('{section_settings_' + key + '}', 'g');
            htmlString = htmlString.replace(regExp, section_settings[key]);
          });
        }
 
        htmlString.replace(new RegExp('remove_false_', 'g'), '');
        htmlString.replace(new RegExp('add_true_', 'g'), '');
 
        var productElement = fragmentFromString(htmlString);
 
        if(htmlString.indexOf("bold_not_available") > -1){
          productPlaceHolder.parentNode.removeChild(productPlaceHolder)
        } else {
          productPlaceHolder.parentNode.replaceChild(productElement, productPlaceHolder);
        }
        // code for different themes
 
        // code for different themes
      } else {
        // We reached our target server, but it returned an error
        console.log(request);
      }
    };
 
    request.onerror = function() {
      // There was a connection error of some sort
      console.log(request);
    };
 
    request.send();
  });
  bold_save_product_scripts.forEach(function(currentScript){
    currentScript.parentNode.removeChild(currentScript);
  });
});
 
 
function fragmentFromString(str){
  return document.createRange().createContextualFragment(str);
}